export default {
  event_overview: {
    title: 'Event Overview',
    type: {
      Physical: 'In-person',
      Online: 'Virtual',
      Hybrid: 'Hybrid',
    },
    overview_prefix: {
      date: 'Date:',
      location: 'Location:',
      event_type: 'Event Type:',
      organization: 'Organization:',
      plan: 'Plan:',
      add_ons: 'Add-Ons:',
    },
    menu: {
      export: 'Export Usage Data',
      clone: 'Clone Event',
      delete: 'Delete Event',
      copy: 'Copy Event Website Link',
      event_id: 'Event ID',
      publish: 'Publish',
      aria: 'Toggle the event menu',
    },
    registration: {
      stats_pending_payment: 'With a pending payment',
      stats_registered: 'Registered',
      stats_waitlist: 'On waitlist',
      stats_with_abstract: 'With a submission',
      stats_withdrawn: 'Withdrawn',
      header: 'Registrations',
      action_period: 'Change dates',
      period: 'Registration period',
      confirmation_email: 'Confirmation email',
      confirmation_email_text: 'Edit the email sent after a registration.',
      action_confirmation_email: 'Edit email',
      action_plan_alert: 'Go to Registration Settings',
      card: {
        title: 'Registration',
        view: 'View Registration',
        created: 'Registered',
        edit: 'Edit Registration',
        empty_state: 'The submitter has not registered to this event.',
        empty_state_user: `You're not registered to this event.`,
      },
    },
    reviews: {
      header: 'Reviews',
      pending: 'Pending',
      completed: 'Completed',
      conflict_of_interest: 'Conflict of interest',
      period: 'Review period',
      action_period: 'Change dates',
    },
    submission: {
      header: 'Submissions',
      stats_submitted: 'Submitted',
      stats_accepted_for: 'Accepted for',
      stats_waiting: 'Waiting',
      stats_conflict: 'In conflict',
      stats_withdrawn: 'Withdrawn',
      period: 'Submission period',
      action_period: 'Change dates',
      confirmation_email: 'Confirmation email',
      confirmation_email_text: 'Edit the email sent after a submission.',
      action_confirmation_email: 'Edit email',
      action_plan_alert: 'Go to Submission Settings',
      card_title: 'Submission',
      card_edit: 'Edit Submission',
    },
    transactions: {
      header: 'Payments',
      stats_total: 'Paid',
      stats_net_profit: 'Profit',
      stats_total_refunded: 'Refunded',
      stats_transactions: 'Payments',
      stats_refunds: 'Refunds',
      stats_transactionFees: 'Transaction fees',
      bank_account: 'Bank account',
      action_view: 'View',
      stripe_connected: 'Stripe account Connected',
      not_connected: 'No account connected',
      action_connect: 'Connect',
      payment_settings: 'Payment settings',
      payment_settings_text: 'Change payment settings.',
    },
    vps: {
      header: 'Virtual Platform',
      stats_posters: 'Virtual Posters',
      stats_participants: 'Participants',
      stats_sessions: 'Sessions',
      access_live_app: 'Access Virtual Platform',
      activation_message: 'Activate the Virtual Platform banner so it appears on your event website during your event.',
      activation_cta: 'Activate Now',
    },
    communications: {
      header: 'Communications',
    },
    export: {
      modal_title: 'Export Usage Data',
      modal_content: 'An Excel file will be sent to your email inbox within the next hour.',
    },
  },
};
